import { createContext } from "react";
import usePermissions from "../../hooks/auth/usePermissions";

interface IPermissionsContext extends ReturnType<typeof usePermissions> {

}

const PermissionsContext = createContext<IPermissionsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default PermissionsContext;